<template>
  <layout>
    <div slot="content">
      <i-card title="线路套餐">
        <div slot="content">
          <el-table
            v-loading="loading"
            :border="true"
            :highlight-current-row="true"
            :data="shipList"
            style="width: 100%">
            <el-table-column
              prop="id"
              label="产品ID"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="cover_pic"
              label="封面图片"
              width="110"
            >
              <el-image slot-scope="scope" lazy
                        style="width: 80px; height: 80px;border:1px solid #eee;border-radius: 10px"
                        :preview-src-list="[scope.row.cover_pic]" :src="scope.row.cover_pic" fit="cover"/>
            </el-table-column>
            <el-table-column
              prop="title"
              label="套餐名称"
              min-width="200"
            >
            </el-table-column>
            <el-table-column
              prop="sale_count"
              label="销量"
              width="100"
            >
            </el-table-column>
            <el-table-column
              label="销售状态"
              width="100"
            >
              <template slot-scope="scope">
                <el-tag size="mini" type="success" v-if="scope.row.on_sale === 1">销售中</el-tag>
                <el-tag size="mini" type="danger" v-else>已下架</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="创建时间"
              width="160"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              width="150"
              fixed="right"
            >
              <div style="text-align: center" slot-scope="scope">
                <router-link :to="{name:'product.edit_trip',query:{product_id:scope.row.id}}"
                             style="margin-right: 10px">
                  <el-link size="mini" type="primary" :underline="false">编辑</el-link>
                </router-link>
                <el-dropdown>
                  <el-link size="mini" type="primary" :underline="false">
                    更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-link size="mini" type="primary" :underline="false" @click="setDistribution(scope.row.id)">
                        分销
                      </el-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-link size="mini" type="primary" :underline="false"
                               @click="setExtension(scope.row.id,scope.row.title)"
                      >扩展设置
                      </el-link>
                    </el-dropdown-item>
<!--                    <el-dropdown-item>-->
<!--                      <el-link size="mini" type="primary" :underline="false"-->
<!--                               @click="setBindPlay(scope.row.id,scope.row.title)"-->
<!--                      >绑定场次-->
<!--                      </el-link>-->
<!--                    </el-dropdown-item>-->
                    <el-dropdown-item>
                      <el-link size="mini" type="primary" :underline="false" :disabled="scope.row.on_sale!=1"
                               @click="setStock(scope.row.id,scope.row.title)">库存设置
                      </el-link>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

              </div>
            </el-table-column>
          </el-table>
        </div>
        <div slot="right-menu">
          <router-link :to="{name:'product.add_trip'}">
            <el-button type="success" size="medium" icon="el-icon-plus">新建线路套餐</el-button>
          </router-link>
        </div>
      </i-card>
      <i-fx :show="showFxStatus" :product-id="currProductId" @change="showFx"></i-fx>
      <i-extension :show="showExtensionStatus" :product-id="currProductId" :goods-title="currGoodsTitle"
                   @change="showExtension"></i-extension>
      <i-stock :show="showStockStatus" :product-id="currProductId" :goods-title="currGoodsTitle"
               @change="setShowStock"/>


    </div>
  </layout>
</template>

<script>
import iFx from "@/components/i-fenxiao"
import iExtension from "@/components/i-extension"
import iStock from "@/components/i-stock"
import iBindPlay from "@/components/i-bind-play"


export default {
  name: "ship",
  components: {iFx, iExtension, iStock, iBindPlay},
  data() {
    return {
      shipList: [],
      loading: false,
      dialogVisible: false,
      distributionInfo: ['', ''],
      currUnicode: '',
      currProductId: '',
      currGoodsTitle: '',
      showFxStatus: false,
      distributionLoading: false,
      bindSailingsDialog: false,
      bindSailingsLoading: false,
      selectedSailings: "",
      sailingsList: [],
      currShipId: "",
      showExtensionStatus: false,
      showStockStatus: false,
      showBindPlay:false,

    }
  },
  methods: {
    setDistribution: function (productId) {
      this.showFxStatus = true;
      this.currProductId = productId;
    },
    showFx: function (show) {
      this.showFxStatus = show;
    },
    setExtension: function (productId, title) {
      this.showExtensionStatus = true;
      this.currProductId = productId;
      this.currGoodsTitle = title;
    },
    showExtension: function (show) {
      this.showExtensionStatus = show;
    },
    setStock: function (productId, title) {
      this.showStockStatus = true;
      this.currProductId = productId;
      this.currGoodsTitle = title;
    },
    setShowStock: function (show) {
      this.showStockStatus = show;
    },
    setShowBindPlay: function (show) {
      this.showBindPlay = show;
    },
    setBindPlay: function (productId, title) {
      this.showBindPlay = true;
      this.currProductId = productId;
      this.currGoodsTitle = title;
    },
    getShipList: function () {
      let _self = this;
      this.loading = true;
      this.$http.request('productList', {type: 10}).then((res) => {
        _self.shipList = res.data;
        _self.loading = false;
      });
    },
    getInfo(val) {
      this.selectedSailings = "";
      val.forEach((row) => {
        this.selectedSailings += row.id + ",";
      });
    },
    postBind: function () {
      this.bindSailingsLoading = true;
      this.$http.request('doBindSailings', {
        ship_id: this.currShipId,
        sailingIds: this.selectedSailings
      }).then((res) => {
        this.bindSailingsLoading = false;
        this.bindSailingsDialog = false;
        this.$message({
          message: res.message,
          type: 'success'
        });
      });
    },
    delProduct: function (id) {
      this.$confirm('是否删除该商品？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.request('delProduct', {product_id: id}).then((res) => {
          let _self = this;
          if (res.status === 'success') {
            this.$message({
              type: 'success',
              message: res.message,
              onClose: function () {
                _self.getShipList();
              }
            });
          }
        });
      })
    }
  },
  created: function () {
    this.getShipList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product/trip.vue